@if (initialized && model) {
  <div>
    @if (model?.subscription && step === 'choose-ai-tariff') {
      <app-ai-tariff-select 
        (back)="resetWorkflow()"
        [currentPlan]="model.currentPlan"
        [aiTariffs]="model.tariffList"
        (selected)="onAITariffSelected($event)">
      </app-ai-tariff-select>
    }
    @if (model?.subscription && step === 'delivery-date') {
      <app-tariff-place-order
        (back)="onTariffDeliveryDateBack()"
        [selectedTariff]="'workflow-partner-ai-tariff_' + aiTariffService.getTariffIdentifier(AITariffType[model.selectedPlan.tariffType])"
        [currentTariff]="'workflow-partner-ai-tariff_' + aiTariffService.getTariffIdentifier(AITariffType[model.currentPlan.tariffType])"
        (selected)="onTariffDeliveryDateSelected($event)">
      </app-tariff-place-order>
    }
    @if (model?.customer && model?.subscription && step === 'contact') {
      <app-select-invoice-contact
        [customer]="model.customer"
        [subscription]="model.subscription"
        (back)="onContactBack()"
        [historyBack]="false"
        (selected)="onContact($event)">
      </app-select-invoice-contact>
    }
    @if (step === 'invoice-address') {
      <app-invoice-address
        [historyBack]="false"
        (backEvent)="onInvoiceAddressBack()"
        [backLabel]="'app_back'"
        [company]="model.company"
        (next)="onInvoiceAddressFilled($event)"
      ></app-invoice-address>
    }
    @if (model?.subscription && step === 'payment-method') {
      <app-payment-method 
        [paymentMethod]="paymentMethod" 
        [historyBack]="false" 
        (backEvent)="onPaymentMethodBack()" 
        (next)="onPaymentMethodSelected($event)">
      </app-payment-method>
    }
    @if (model?.subscription && step === 'checkout-summary') {
      <app-checkout-one-summary
        backLabel="app_cancel"
        [historyBack]="false"
        [subscription]="model.subscription"
        (back)="onSummaryBack()"
        (buy)="onSummaryBuy()"
      ></app-checkout-one-summary>
    }
    @if (step === 'complete') {
      <app-partner-upgrade-offer-sent
        (next)="onComplete()"
        [customerEmail]="model.saleOrder.contact.email">
      </app-partner-upgrade-offer-sent>
    }
  </div>
}